import FormattedOccupancy from 'components/Common/OccupancyPicker/FormattedOccupancy'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import { generateOfferPageRoom } from 'contexts/OfferPage/offerPageStateReducer'
import type { ComponentProps } from 'react'
import React from 'react'

interface Props extends Pick<ComponentProps<typeof FormattedOccupancy>, 'adultLabel'> {
  bundleOfferId?: string
  offer?: App.Offer
  rooms?: Array<App.RoomOccupants>
}

const DEFAULT_ROOMS = [generateOfferPageRoom()]

function OfferPageFormattedOccupancy(props: Props) {
  const { adultLabel, bundleOfferId, offer, rooms = DEFAULT_ROOMS } = props

  return <FormattedOccupancy
    adultLabel={adultLabel}
    occupancies={rooms}
    saleUnit={!bundleOfferId ? offer?.saleUnit : undefined}
  />
}

export default withOfferPageState((offerPageState) => ({
  bundleOfferId: offerPageState.bundleOffer?.id,
  offer: offerPageState.offer,
  rooms: offerPageState.rooms,
}), OfferPageFormattedOccupancy)
